import { AdditionalInformation } from './fields/AdditionalInformation'
import { Company } from './fields/Company'
import { ContactInformation } from './fields/ContactInformation'
import { EligibilityAndReccurrence } from './fields/EligibilityAndReccurrence'
import { Loads } from './fields/Loads'

import { Priority } from './fields/Priority'
import { RequiredVehicle } from './fields/RequiredVehicle'
import { ServiceTimeAndAvailabilities } from './fields/ServiceTimeAndAvailabilities'

import { Divider } from '@mui/material'

interface Props {
  orders: uui.domain.client.rm.ExtendedOrderStep[]
}

export function FormContent(props: Props) {
  const { orders } = props

  return (
    <>
      <Company />
      <Divider />
      <EligibilityAndReccurrence />
      <Divider />
      <Loads orders={orders} />
      <RequiredVehicle />
      <Priority />
      <Divider />
      <ContactInformation />
      <Divider />
      <ServiceTimeAndAvailabilities />
      <AdditionalInformation />
    </>
  )
}
